import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { IHistory } from '../../interfaces';
import { PlantModel } from '../../model/PlantModel';

export interface IListItemProps {
    instance: PlantModel;
    index: number;
    history: IHistory;
}

export class ListItemImpl extends React.PureComponent<IListItemProps, {}> {

    static defaultProps: IListItemProps;

    render() {
        const { instance, index, history } = this.props;
        return <Row className="form-list-item" >
            <Col
                className="clickable-list-item serial-no"
                sm={2} xs={2}
            >
                {index}
            </Col>
            <Col
                className="clickable-list-item" xs={3}
                sm={3}
            >
                {instance.props.PlantId}
            </Col>
            <Col
                className="clickable-list-item" xs={4}
                sm={4}
            >
                {instance.props.Plant_Region}
            </Col>
            <Col
                className="clickable-list-item" xs={3}
                sm={3}
            >
                {instance.props.State}
            </Col>
        </Row>;
    }
}

export function mapStateToProps(state) {
    return {
        state
    };
}

export const ListItem = withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Inspections/ListItem.tsx